import { useEffect, useState } from 'react';
import { AppName } from '../../apps/definition';
import { invokeFastApi } from '../apis/fastapi';
import { logError } from '../utils';
import { useToaster } from './toast';

interface AppFilter {
  app_id: number;
  app_name: AppName;
}

export interface QuerySuggestion {
  suggested_query: string;
  app_filter: AppFilter[];
}

interface QuerySuggestionsResponse {
  querySuggestions: QuerySuggestion[];
  loading: boolean;
  error: boolean;
  getQuerySuggestions: () => void;
}

export const useQuerySuggestions = (): QuerySuggestionsResponse => {
  const [querySuggestions, setQuerySuggestions] = useState<QuerySuggestion[]>(
    []
  );

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const toaster = useToaster();

  const getQuerySuggestions = async () => {
    setLoading(true);
    setError(false);
    setQuerySuggestions([]);
    try {
      const { suggestions } = await invokeFastApi<{
        suggestions: QuerySuggestion[];
      }>({
        path: '/_userQuerySuggestion',
        method: 'GET',
      });

      setQuerySuggestions(suggestions);
    } catch (fetchError) {
      logError(fetchError);
      setError(true);
      toaster.failure('Failed to fetch query suggestions');
    }

    setLoading(false);
  };

  useEffect(() => {
    getQuerySuggestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { querySuggestions, loading, error, getQuerySuggestions };
};
